const getCompanies = async ({ url, api }) => {
  return await api(`${url}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getCompanies;